import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";

import { SurveyNoVerify } from "./sopDataTemplate";
interface AllProps {
  data: SurveyNoVerify;
  handleSurveyNoVerify: any;
}
export class SurveyNoVerification extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: '#ffff8d',
    responseData: {},
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
        const { bgColor } = this.state;
        if (bgColor !== 'lightgreen') {
            this.setState({ bgColor: 'lightgreen' })
        }
    }

  //   handleChildChange = (e, type, index?) => {
  //     const { data } = this.props;
  //     if (index !== undefined) data[type][index][e.target.name] = e.target.value;
  //     else data[type][e.target.name] = e.target.value;
  //     this.changeBgColor();
  //     data.bgColor = "lightgreen";
  //     this.props.handleSurveyNoVerify(data);
  //   };
  handleChildChange = (
    fieldOrEvent: string | React.ChangeEvent<HTMLInputElement>,
    typeOrValue: string | boolean | number,
    index?: number,
    directValue?: boolean | string | number,
  ) => {
    const { data } = this.props;

    let fieldName: string;
    let fieldValue: any;
    let arrayName: string;
    let arrayIndex = index;

    if (typeof fieldOrEvent === "object" && fieldOrEvent.target) {
      // Case: Text input → event passed
      const e = fieldOrEvent as React.ChangeEvent<HTMLInputElement>;
      fieldName = e.target.name;
      fieldValue = e.target.value;
      arrayName = typeOrValue as string; // second param is array name
    } else {
      // Case: Radio/Checkbox → direct field + value
      fieldName = fieldOrEvent as string;
      fieldValue = directValue !== undefined ? directValue : typeOrValue;
      arrayName = typeOrValue as string; // second param is array name
      // index is third param
    }

    // Update the nested array item
    if (
      arrayIndex !== undefined &&
      data[arrayName] &&
      data[arrayName][arrayIndex]
    ) {
      data[arrayName][arrayIndex][fieldName] = fieldValue;
    }

    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleSurveyNoVerify(data);
  };
  handleChange = (e) => {
    const { data } = this.props;
    data[e.target.name] = e.target.value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleSurveyNoVerify(data);
  };
  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };
  addChild = (type) => {
    const { data } = this.props;
    if (type === "titleDeed") {
      data[type].push({
        oldSurveyNo: "",
        surveyNo: "",
        tslrNo: "",
        Corelation: "",
        proceedingpatta: false,
        deedExtentverfy: "",
        roadAppBound: false,
        pathwayBound: false,
        ofbyBoundverfy: false,
        boundverfyNorth: "",
        boundverfySouth: "",
        boundverfyEast: "",
        boundverfyWest: "",
        northeastMeasur: "",
        southeastMeasur: "",
        eastnorthMeasur: "",
        westnorthMeasur: "",
        measurementextentmatch: "",
        landTypeNanjai: false,
        NonAgrifromtashidar: false,
        deedDoorNoverfy: "",
        deedplotNoverfy: "",
        deedlayoutnameverfy: "",
        deedstreetnameverfy: "",
        deedflatnoverfy: "",
        deedapartnameverfy: "",
        deedapartcompletioncert: false,
        deedvillagename: "",
        deedregisterdistrict: "",
        sROVerified: "",
        newtalukVerified: "",
        extent: "",
        name: "",
      });
    } else if (type === "register") {
      data[type].push({
        surveyNo: "",
        tslrNo: "",
        extent: "",
        name: "",
        aRegisterMeanscompare: false,
      });
    } else if (type === "currentPatta") {
      data[type].push({
        surveyNo: "",
        tslrNo: "",
        extent: "",
        name: "",
        governmentLandorNotverify: "",
      });
    }
    this.props.handleSurveyNoVerify(data);
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    this.props.handleSurveyNoVerify(data);
  };

  getAddButton = (
    title: string,
    value: string,
    showRadioForSection?: boolean,
  ) => {
    const { data } = this.props;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h6 style={{ margin: 0 }}>
            <b>
              {title} {title === "A Register" ? "/ From Para Patta" : ""}
            </b>
          </h6>

          {/* Show radio buttons only for the specified section */}
          {showRadioForSection === true && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              <Form.Check
                inline
                label="Yes"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-yes`}
                checked={data[`isshow${value}Status`] === true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = true;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleSurveyNoVerify(data);
                }}
                style={{ marginRight: "15px" }}
              />
              <Form.Check
                inline
                label="No"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-no`}
                checked={data[`isshow${value}Status`] === false} // FIXED: Explicitly check for false
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = false;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleSurveyNoVerify(data);
                }}
              />
            </div>
          )}
        </div>

        <div onClick={() => this.addChild(value)}>
          <button
            className="btn btn-sm btn-primary"
            style={{ fontSize: "smaller" }}
          >
            Add {title}
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { data } = this.props;
    const { isOptionOpen,bgColor } = this.state;

    return (
      <div className="collapse-section survey-no-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data.bgColor ? data.bgColor : bgColor }}
              as={Card.Header}
              eventKey="1"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Survey No Verification</b>
              </h5>
              <i
                className={`icon feather icon-${
                  !isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <div>
                  {this.getAddButton("A Register", "register", true)}

                  {data.register.length > 0 &&
                    data.register.map((registerValue, valueIndex) => {
                      return (
                        <div className="row" key={valueIndex}>
                          <div
                            className="form-group col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Survey No
                            </label>
                            <input
                              className="form-control"
                              name="surveyNo"
                              type="text"
                              value={registerValue?.surveyNo}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "register",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              TSLR No
                            </label>
                            <input
                              className="form-control"
                              name="tslrNo"
                              type="text"
                              value={registerValue?.tslrNo}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "register",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group  col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Extent
                            </label>
                            <input
                              className="form-control"
                              name="extent"
                              type="text"
                              value={registerValue?.extent}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "register",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group  col-md-5"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Name
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              value={registerValue?.name}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "register",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Origin A Register Means Compare with Title Deed
                              Survey Number
                            </label>
                           
                            <input
                              className="form-control"
                              name="aRegisterMeanscompare"
                              type="text"
                              value={registerValue?.aRegisterMeanscompare}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "register",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          {this.checkOperation(
                            "register",
                            registerValue,
                            valueIndex,
                          ) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                marginBottom: 0,
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("register", valueIndex)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Title Deed", "titleDeed")}
                  {data.titleDeed.length > 0 &&
                    data.titleDeed.map((titleDeedValue, valueIndex) => {
                      return (
                        <div className="row mb-4" key={valueIndex}>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Old Survey Number Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="oldSurveyNo"
                                type="text"
                                value={
                                  (titleDeedValue?.oldSurveyNo as string) || ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              New Survey Number Verified
                            </label>
                            <input
                              className="form-control"
                              name="surveyNo"
                              type="text"
                              value={titleDeedValue?.surveyNo}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "titleDeed",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              New Survey Number Verified with Patta Extract
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>

                            <input
                              className="form-control"
                              name="pattaExtractSno"
                              type="text"
                              value={titleDeedValue?.pattaExtractSno || ""}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "titleDeed",
                                  valueIndex,
                                )
                              }
                            />
                            </div>
                          </div>
                          <div className="form-group  mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Proceeding of Patta Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="proceedingpatta"
                                type="text"
                                value={
                                  (titleDeedValue?.proceedingpatta) ||
                                  ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Corelation Certificate Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                         
                              <input
                                className="form-control"
                                name="Corelation"
                                type="text"
                                value={
                                  (titleDeedValue?.Corelation as string) || ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Title Deed Extent ( Sq.Mt, Sq.Ft ,Cents) Verified
                            </label>
                            <input
                              className="form-control"
                              name="extent"
                              type="text"
                              value={titleDeedValue?.extent}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "titleDeed",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group mb-4 col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Title Deed Extent Verified With Patta Extract
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              
                              <input
                                className="form-control"
                                name="deedExtentverfy"
                                type="text"
                                value={
                                  (titleDeedValue?.deedExtentverfy as string) ||
                                  ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div
                            className="form-group mb-4 col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Road Approach Available in Boundaries
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`roadAppBound-${valueIndex}`}
                                type="radio"
                                checked={titleDeedValue?.roadAppBound === true}
                                onChange={() =>
                                  this.handleChildChange(
                                    "roadAppBound",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`roadAppBound-${valueIndex}`}
                                type="radio"
                                checked={titleDeedValue?.roadAppBound !== true}
                                onChange={() =>
                                  this.handleChildChange(
                                    "roadAppBound",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                            </div>
                          </div>

                          <div
                            className="form-group  mb-4 col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Pathway Available in Boundaries
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`pathwayBound-${valueIndex}`}
                                type="radio"
                                checked={titleDeedValue?.pathwayBound === true}
                                onChange={() =>
                                  this.handleChildChange(
                                    "pathwayBound",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`pathwayBound-${valueIndex}`}
                                type="radio"
                                checked={titleDeedValue?.pathwayBound !== true}
                                onChange={() =>
                                  this.handleChildChange(
                                    "pathwayBound",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Of /BY Boundaries direction Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`ofbyBoundverfy-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.ofbyBoundverfy === true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "ofbyBoundverfy",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`ofbyBoundverfy-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.ofbyBoundverfy !== true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "ofbyBoundverfy",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Boundary of North Verified{" "}
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="boundverfyNorth"
                                type="text"
                                value={titleDeedValue?.boundverfyNorth || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Boundary of South Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="boundverfySouth"
                                type="text"
                                value={titleDeedValue?.boundverfySouth || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Boundary of East Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="boundverfyEast"
                                type="text"
                                value={titleDeedValue?.boundverfyEast || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Boundary of West Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="boundverfyWest"
                                type="text"
                                value={titleDeedValue?.boundverfyWest || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              North- East West Measureements in Sq.Ft/ Sq.Mt
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="northeastMeasur"
                                type="text"
                                value={titleDeedValue?.northeastMeasur || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              South- East West Measurements in Sq.Ft/ Sq.Mt
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="southeastMeasur"
                                type="text"
                                value={titleDeedValue?.southeastMeasur || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              East- North South Measurements In Sq.Ft/ Sq.Mt
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="eastnorthMeasur"
                                type="text"
                                value={titleDeedValue?.eastnorthMeasur || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              West- North South Measurements Sq.Ft/ Sq.Mt
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="westnorthMeasur"
                                type="text"
                                value={titleDeedValue?.westnorthMeasur || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Measurement Extent Matched with Title Deed Total
                              Extent
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="measurementextentmatch"
                                type="text"
                                value={
                                  titleDeedValue?.measurementextentmatch || ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Land type is Nanjai (Yes Means
                              Hold/Policy/Approval)
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`landTypeNanjai-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.landTypeNanjai === true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "landTypeNanjai",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`landTypeNanjai-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.landTypeNanjai !== true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "landTypeNanjai",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Is Title Extent more than 20 Cents( Non Agri From
                              Tahsildar)
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`NonAgrifromtashidar-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.NonAgrifromtashidar === true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "NonAgrifromtashidar",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`NonAgrifromtashidar-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.NonAgrifromtashidar !== true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "NonAgrifromtashidar",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Door No Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedDoorNoverfy"
                                type="text"
                                value={titleDeedValue?.deedDoorNoverfy || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Plot No Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedplotNoverfy"
                                type="text"
                                value={titleDeedValue?.deedplotNoverfy || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Layout Name Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedlayoutnameverfy"
                                type="text"
                                value={
                                  titleDeedValue?.deedlayoutnameverfy || ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Street Name Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedstreetnameverfy"
                                type="text"
                                value={
                                  titleDeedValue?.deedstreetnameverfy || ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Flat No Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedflatnoverfy"
                                type="text"
                                value={titleDeedValue?.deedflatnoverfy || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Apartment Name Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedapartnameverfy"
                                type="text"
                                value={titleDeedValue?.deedapartnameverfy || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Apartment Completion Certificate available
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="deedapartcompletioncert"
                                type="text"
                                value={String(
                                  titleDeedValue?.deedapartcompletioncert || "",
                                )}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Village Name Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`deedvillagename-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.deedvillagename === true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "deedvillagename",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`deedvillagename-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.deedvillagename !== true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "deedvillagename",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                              {/* <input
                                className="form-control"
                                name="deedvillagename"
                                type="text"
                                value={titleDeedValue?.deedvillagename || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              /> */}
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              Registered District Verified
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`deedregisterdistrict-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.deedregisterdistrict === true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "deedregisterdistrict",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`deedregisterdistrict-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.deedregisterdistrict !== true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "deedregisterdistrict",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                              {/* <input
                                className="form-control"
                                name="deedregisterdistrict"
                                type="text"
                                value={
                                  titleDeedValue?.deedregisterdistrict || ""
                                }
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              /> */}
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              New SRO Verified with EC
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <input
                                className="form-control"
                                name="sROVerified"
                                type="text"
                                value={titleDeedValue?.sROVerified || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 col-md-5 no-right-padding">
                            <label className="label" style={{ padding: 0 }}>
                              New Taluk Verified with Patta
                            </label>
                            <div className="row" style={{ marginRight: 10 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`newtalukVerified-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.newtalukVerified === true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "newtalukVerified",
                                    "titleDeed",
                                    valueIndex,
                                    true,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`newtalukVerified-${valueIndex}`}
                                type="radio"
                                checked={
                                  titleDeedValue?.newtalukVerified !== true
                                }
                                onChange={() =>
                                  this.handleChildChange(
                                    "newtalukVerified",
                                    "titleDeed",
                                    valueIndex,
                                    false,
                                  )
                                }
                              />
                              {/* <input
                                className="form-control"
                                name="newtalukVerified"
                                type="text"
                                value={titleDeedValue?.newtalukVerified || ""}
                                onChange={(e) =>
                                  this.handleChildChange(
                                    e,
                                    "titleDeed",
                                    valueIndex,
                                  )
                                }
                              /> */}
                            </div>
                          </div>

                          <div
                            className="form-group  col-md-5"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Name
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              value={titleDeedValue?.name}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "titleDeed",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          {this.checkOperation(
                            "titleDeed",
                            titleDeedValue,
                            valueIndex,
                          ) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                marginBottom: 0,
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("titleDeed", valueIndex)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Current Patta/Chitta/TSLR No", "currentPatta", true)}
                  {data.currentPatta.length > 0 &&
                    data.currentPatta.map((pattaValue, valueIndex) => {
                      return (
                        <div className="row">
                          <div
                            className="form-group  col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Survey No
                            </label>
                            <input
                              className="form-control"
                              name="surveyNo"
                              type="text"
                              value={pattaValue?.surveyNo}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "currentPatta",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              TSLR No
                            </label>
                            <input
                              className="form-control"
                              name="tslrNo"
                              type="text"
                              value={pattaValue?.tslrNo}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "currentPatta",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group  col-md-5 no-right-padding"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Extent
                            </label>
                            <input
                              className="form-control"
                              name="extent"
                              type="text"
                              value={pattaValue?.extent}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "currentPatta",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group  col-md-5"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Name
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              value={pattaValue?.name}
                              onChange={(e) =>
                                this.handleChildChange(
                                  e,
                                  "currentPatta",
                                  valueIndex,
                                )
                              }
                            />
                          </div>
                          <div
                            className="form-group  col-md-5"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Government Land or Not -Verified
                            </label>
                            <Form.Check
                              inline
                              label="Yes"
                              name="governmentLandorNotverify"
                              type="radio"
                              checked={
                                pattaValue.governmentLandorNotverify === true
                              }
                              onChange={() =>
                                this.handleChildChange(
                                  "governmentLandorNotverify",
                                  "currentPatta",
                                  valueIndex,
                                  true,
                                )
                              }
                            />
                            <Form.Check
                              inline
                              label="No"
                              name="governmentLandorNotverify"
                              type="radio"
                              checked={
                                pattaValue.governmentLandorNotverify === false
                              }
                              onChange={() =>
                                this.handleChildChange(
                                  "governmentLandorNotverify",
                                  "currentPatta",
                                  valueIndex,
                                  false,
                                )
                              }
                            />
                          </div>
                          {this.checkOperation(
                            "currentPatta",
                            pattaValue,
                            valueIndex,
                          ) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                marginBottom: 0,
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("currentPatta", valueIndex)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  <div className="row">
                    <div className="form-group  col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Total Survey No In Title Deed
                      </label>
                      <input
                        className="form-control"
                        name="totalTitleDeed"
                        type="text"
                        value={data.totalTitleDeed}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="form-group  col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Total Survey No In EC
                      </label>
                      <input
                        className="form-control"
                        name="totalEc"
                        type="text"
                        value={data.totalEc}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="form-group  col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Diffrence
                      </label>
                      <input
                        className="form-control"
                        name="difference"
                        type="text"
                        value={data.difference}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="form-group  col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Missing Survey No In EC
                      </label>
                      <input
                        className="form-control"
                        name="missingEc"
                        type="text"
                        value={data.missingEc}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="form-group col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Land Type 
                      </label>
                      <div className="row" style={{ marginLeft: 10 }}>
            
                        <select
                          className="form-control"
                          name="type"
                          value={data.type}
                          onChange={this.handleChange}
                        >
                          <option value="Nanjai">Nanjai</option>
                          <option value="Punjai">Punjai</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group  col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Patta Verified with QR Code
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="pattaqrcode"
                          type="radio"
                          checked={data.pattaqrcode}
                          onChange={() =>
                            this.handleChange({
                              target: { name: "pattaqrcode", value: true },
                            })
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="pattaqrcode"
                          type="radio"
                          checked={!data.pattaqrcode}
                          onChange={() =>
                            this.handleChange({
                              target: { name: "pattaqrcode", value: false },
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group  col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Attachment Proof Submitted for Verified QR Code
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="proofverifyqrcode"
                          type="radio"
                          checked={data.proofverifyqrcode}
                          onChange={() =>
                            this.handleChange({
                              target: {
                                name: "proofverifyqrcode",
                                value: true,
                              },
                            })
                          }
                        />
                        <Form.Check
                          inline
                          label="NO"
                          name="proofverifyqrcode"
                          type="radio"
                          checked={!data.proofverifyqrcode}
                          onChange={() =>
                            this.handleChange({
                              target: {
                                name: "proofverifyqrcode",
                                value: false,
                              },
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group  col-md-4 no-right-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Patta Issued by Verified
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <input
                          className="form-control"
                          name="pattaissuedverfy"
                          type="text"
                          value={data.pattaissuedverfy}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group  col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Condition Patta
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="conditionPatta"
                          type="radio"
                          checked={data.conditionPatta}
                          onChange={() =>
                            this.handleChange({
                              target: { name: "conditionPatta", value: true },
                            })
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="conditionPatta"
                          type="radio"
                          checked={!data.conditionPatta}
                          onChange={() =>
                            this.handleChange({
                              target: { name: "conditionPatta", value: false },
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default SurveyNoVerification;
